var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3144 1H14.6856C14.9803 1 15.2629 1.11706 15.4713 1.32544L20.6746 6.52873C20.8829 6.7371 21 7.01971 21 7.3144V14.6856C21 14.9803 20.8829 15.2629 20.6746 15.4713L15.4713 20.6746C15.2629 20.8829 14.9803 21 14.6856 21H7.3144C7.01971 21 6.7371 20.8829 6.52873 20.6746L1.32544 15.4713C1.11706 15.2629 1 14.9803 1 14.6856V7.3144C1 7.01972 1.11706 6.7371 1.32544 6.52873L6.52873 1.32544C6.7371 1.11706 7.01972 1 7.3144 1Z",
    stroke: "#01BA3A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 8.77832L9.88885 13.2228L7.66663 11.0005",
    stroke: "#01BA3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCheck);
export default __webpack_public_path__ + "static/media/status-check.4a93ed135bc0a518a846e0558751518d.svg";
export { ForwardRef as ReactComponent };